export const OPENAI_LUNA_MODEL = 'gpt-5.6-luna';

const SPECIALIZED_OPENAI_MODEL_MARKERS = ['audio', 'realtime', 'transcribe', 'tts'] as const;

export function isGpt4FamilyOpenAiModel(model: string | null | undefined): boolean {
    const normalized = normalizeOpenAiModel(model);
    return normalized.startsWith('gpt-4') || normalized.startsWith('chatgpt-4');
}

export function isDeprecatedGeneralOpenAiModel(model: string | null | undefined): boolean {
    const normalized = normalizeOpenAiModel(model);
    const isGpt4Family = normalized.startsWith('gpt-4') || normalized.startsWith('chatgpt-4');
    const isSpecialized = SPECIALIZED_OPENAI_MODEL_MARKERS.some((marker) => normalized.includes(marker));

    return isGpt4Family && !isSpecialized;
}

function normalizeOpenAiModel(model: string | null | undefined): string {
    return (model ?? '')
        .trim()
        .toLowerCase()
        .replace(/^openai(?:::|[:.])\s*/, '');
}

export const Models = {
    AvailableOpenAIModels: [
        OPENAI_LUNA_MODEL,
        'o3-mini',
        'gpt-5.2',
        'gpt-5-pro',
    ],
    AudioOpenAIModels: ['gpt-4o-audio-preview'],
} as const;
